import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';
import type { Provider } from '../../domain/entities/sales.entity';

/** Contas do gateway (`ProviderAccount`) cadastradas no Sales, para popular combos de outros módulos. */
export function useProviderAccounts(provider?: Provider) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'provider-accounts', provider ?? ''],
    queryFn: () => repository.listProviderAccounts({ provider }),
    staleTime: 1000 * 60 * 5,
  });
}
